module.exports = __webpack_public_path__ + "static/media/pi2c-header.99eb1182.jpg";